module.exports = __webpack_public_path__ + "img/Sin título_1.4.1(1).43cbffe8.jpg";